import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faUser,
	faUnlockAlt,
	faArrowCircleUp,
	faAngleRight,
	faHandHoldingHeart,
	faUserPlus,
	faPlusCircle,
	faTrashAlt,
	faArrowRight
} from "@fortawesome/free-solid-svg-icons";
import { fab, faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
	faUser,
	faUnlockAlt,
	fab,
	faFacebookF,
	faGoogle,
	faArrowCircleUp,
	faAngleRight,
	faHandHoldingHeart,
	faUserPlus,
	faPlusCircle,
	faTrashAlt,
	faArrowRight
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
